import type { CommonAction } from "@iflyrpa/share";

import type { ActiomCommonParams } from "../../types";
import { executeAction } from "../../utils";
import { mockAction } from "./mock";
import { rpaAction } from "./rpa";

export type Source = "ai" | "official" | "fictional" | "personal";

export interface WeixinmpPublishParams extends ActiomCommonParams {
    token: string | number;
    banners?: string[];
    title: string; // 标题
    content: string; // 正文
    /**
     * 内容由AI生成 - ai
     * 素材来源官方媒体/网络新闻 - official
     * 内容剧情演绎，仅供娱乐 - fictional
     * 个人观点，仅供参考  - personal
     */
    source?: Source; // 来源
    draft?: boolean; // 是否为草稿
}

export type PublishAction = CommonAction<WeixinmpPublishParams>;

export const weixinmpPublish: PublishAction = async (task, params) => {
    if (params.actionType === "rpa") {
        return rpaAction(task, params);
    }

    if (params.actionType === "mockApi") {
        return mockAction(task, params);
    }

    return executeAction(mockAction, rpaAction)(task, params);
};
